module.exports = __webpack_public_path__ + "static/media/16import.89d59c76.xlsx";